<template>
  <v-card class="card" outlined width="296">
    <v-list-item three-line class="pa-0">
      <v-list-item-content class="pa-0">
        <div class="text-overline mb-1 pa-0 ma-0">
          <v-chip class="card__tag">
            {{ tag }}
          </v-chip>
        </div>
        <v-list-item-title class="card__title mb-1">
          {{ title }}
        </v-list-item-title>
        <v-card-text class="card__description pa-0 ma-0">
          {{ description }}
        </v-card-text>
        <v-card-actions class="pl-0 mt-0 pa-0">
          <a
            :href="composeLink"
            target="_blank"
            class="btn__link"
            @click="onClickLink"
          >
            <v-btn
              outlined
              class="card__btn"
              depressed
              color="primary"
              height="23"
              block
            >
              View Hint On Tool Page
              <img src="../../assets/open-new-tab-icon.svg" />
            </v-btn>
          </a>
        </v-card-actions>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { SEGMENT_EVENTS } from '../../constants';
export default {
  props: ['tag', 'id', 'title', 'description', 'icon', 'link'],
  computed: {
    composeLink() {
      let result = this.mainPlatformLink + this.link;
      if (result.indexOf('company-analysis/nav') > 0) {
        if (result.slice(-1) !== '/') {
          result += '/';
        }
        const companyId =
          this.$auth.user['http://greenstreet.com/gst_company_id'];
        if (companyId) {
          result += companyId;
        }
      }
      return result;
    },
  },
  data: () => ({
    mainPlatformLink: process.env.VUE_APP_MAIN_PLATFORM_LINK,
  }),
  methods: {
    onClickLink() {
      window.analytics.track(SEGMENT_EVENTS.VIEW_NAVIGATIONAL_HELPFUL_HINT, {
        contentTitle: this.title,
        contentId: this.id,
        contentType: 'Navigational Helpful Hints',
      });
    },
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 24px;
  cursor: text;
}
.card .card__tag {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1px;
  color: #91a092;
  text-transform: capitalize;
  background-color: #e6f5ed !important;
  border-radius: 4px;
  padding: 4px 8px;
  height: 23px;
  width: 112;
}
.card .card__title {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.1px;
  color: var(--v-primary-base);
}
.card .card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  height: 51px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  color: #7b7d7a;
}
.card .btn__link {
  width: 100%;
  text-decoration: none;
}
.card .card__btn {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  border-radius: 2px;
  width: 100%;
  text-transform: capitalize;
}
</style>
